import 'moment/locale/en-gb'
import 'moment/locale/pt'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import moment from 'moment'

const UpdateMomentLocaleHoC = ({ children }) => {
  const { i18n } = useTranslation('packages')

  useEffect(() => {
    moment.locale(i18n.language)
    moment.relativeTimeThreshold('d', 59)
  }, [i18n.language])

  return children
}

export default UpdateMomentLocaleHoC
